module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    staticClass: "mx-5",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "1.2",
      "font-weight": "400"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          Events are great for getting things done and staying in touch with just the people you want.Share photos and videos,\n          have conversations, make plans and more.\n        ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white my-4",
    staticStyle: {
      "height": "70px",
      "text-transform": "capitalize",
      "float": "right",
      "font-size": "18px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          Create an Event\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-5 mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md4": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "white",
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": _vm.styles.general.theme_color_dark
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    key: "tab-1",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "16px"
    },
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("my_location")]), _vm._v("\n                      Events\n                    ")], 1)]), _vm._v(" "), _c('v-tabs-item', {
    key: "tab-2",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "16px"
    },
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n                      Calendar\n                    ")], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.events), function(event) {
    return _c('event-timeline', {
      key: event.eventKey,
      attrs: {
        "event": event
      },
      on: {
        "viewEvent": _vm.viewEvent
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('full-calendar', {
    staticClass: "mx-3 my-3",
    attrs: {
      "events": _vm.events
    },
    on: {
      "eventClick": _vm.eventClick
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('new-events-modal', {
    attrs: {
      "groupRoute": _vm.groupRoute,
      "type": "groupevents",
      "groupId": _vm.groupId,
      "trigger": _vm.dialog
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.dialog = $event
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('event-view-modal', {
    attrs: {
      "dialog": _vm.eventModal,
      "item": _vm.eventData
    },
    on: {
      "update:dialog": function($event) {
        _vm.eventModal = $event
      },
      "closeViewEvent": _vm.closeViewEvent
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f45e9d62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/events.vue
// module id = 1734
// module chunks = 17